import React from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import styles from './security-summary.module.scss';
import TermSheetSecurities from "../../../../../listing-details/components/term-sheet-securities/term-sheet-securities";
import TermSheetParticipants
  from "../../../../../listing-details/components/term-sheet-participants/term-sheet-participants";
import {
  getMannerOfDistribution, getNumberOfSecurity,
  getSecurityForm,
  getSecurityClass,
  getSecurityTypes
} from "../../../../../../../../helpr/listingFormData";


const SecuritySummary = ({listingInfo, saveListingInfo, nextStep}) => {
  const nextHandler = (step) => {
    saveListingInfo({
      ...listingInfo,
      save: 'SUBMIT'
    })
    nextStep(step);
  }

  const backHandler = (step) => {
    nextStep(step);
  }



  const renderTypeValue = key => getSecurityTypes({value: key}).filter(t => t.value === key)[0].name;
  const renderFormValue = key => getSecurityForm().filter(t => t.value === key)[0].name;
  const renderMannerValue = key => getMannerOfDistribution().filter(t => t.value === key)[0].name;
  const renderClassValue = key => getSecurityClass().filter(t => t.value === key)[0].name;
  const renderNumberValue = key => getNumberOfSecurity().filter(t => t.value === key)[0].name;

  return (
    <div className={styles['security-summary-component']}>
      <div className={`${styles['term-sheet-details']} ${styles['panel']}`}>
        <Row>
          <Col xs={12} lg={6}>
            <div className={styles['table-heading']}>
              Security Terms
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Type: <span className={styles['value']}>{renderTypeValue(listingInfo.securityType)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Class: <span className={styles['value']}>{renderClassValue(listingInfo.securityClass)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Form: <span className={styles['value']}>{renderFormValue(listingInfo.securityForm)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Manner of Distribution: <span className={styles['value']}>{renderMannerValue(listingInfo.mannerOfDistrib)}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><div className={styles['spacing']}></div></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['label']}>
              Number of Security: <span className={styles['value']}>{renderNumberValue(listingInfo.numberOfSecurity)}</span>
            </div>
          </Col>
        </Row>
      </div>
      <TermSheetSecurities context={{termSheet: listingInfo}} />
      <TermSheetParticipants context={{termSheet: listingInfo}} />
      <Row className={styles['btn-actions']}>
        <Button className="btn-secondary" onClick={()=>backHandler(true)}>BACK</Button>
        <Button onClick={()=>nextHandler()}>SUBMIT</Button>
      </Row>
    </div>
  )
}

export default SecuritySummary;


